export default __webpack_public_path__ + "static/media/header_picture.2257672e.jpeg";